import { render, staticRenderFns } from "./AppAbout.vue?vue&type=template&id=ca7445d0&scoped=true"
import script from "./AppAbout.vue?vue&type=script&lang=js"
export * from "./AppAbout.vue?vue&type=script&lang=js"
import style0 from "./AppAbout.vue?vue&type=style&index=0&id=ca7445d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7445d0",
  null
  
)

export default component.exports